import { StyleType } from '@wix/editor-platform-ooi-metadata-resolver';
import { StyleParamType, createStylesParams } from '@wix/tpa-settings';
import type { ExtractStyleParamValue } from 'root/components/Menus/stylesParams';

export type IDisplayStylesParams = {
  showTabs: StyleParamType.Boolean;
  showSectionTabs: StyleParamType.Boolean;
  showMenuName: StyleParamType.Boolean;
  showMenuDescription: StyleParamType.Boolean;
  showSectionName: StyleParamType.Boolean;
  showSectionDescription: StyleParamType.Boolean;
  showSectionDividers: StyleParamType.Boolean;
  showSectionImage: StyleParamType.Boolean;
  showItemDescription: StyleParamType.Boolean;
  showItemPrice: StyleParamType.Boolean;
  showItemCurrency: StyleParamType.Boolean;
  showItemDiscounts: StyleParamType.Boolean;
  showItemLabels: StyleParamType.Boolean;
  showItemImage: StyleParamType.Boolean;
  showItemLabelsName: StyleParamType.Boolean;
  showItemLabelsIcon: StyleParamType.Boolean;
  showItemDividers: StyleParamType.Boolean;
  showItemVariantsName: StyleParamType.Boolean;
  showItemVariantsPrice: StyleParamType.Boolean;
  showItemVariantsCurrency: StyleParamType.Boolean;
  showItemVariantsDiscounts: StyleParamType.Boolean;
  showItemVariantsDivider: StyleParamType.Boolean;
  showMenusSideImage: StyleParamType.Boolean;
  showModifierGroupName: StyleParamType.Boolean;
  showModifierName: StyleParamType.Boolean;
  showModifierPrice: StyleParamType.Boolean;
  showModifierCurrency: StyleParamType.Boolean;
  showDots: StyleParamType.Boolean;
  showColumnDividers: StyleParamType.Boolean;
  showItemGridDivider: StyleParamType.Boolean;
};

export type DisplayStylesParamsValues = {
  [K in keyof IDisplayStylesParams]: ExtractStyleParamValue<(typeof DisplayStylesParams)[K]>;
};

export const DisplayStylesParams = createStylesParams<IDisplayStylesParams>({
  showTabs: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: { type: 'static', value: true },
    },
  },
  showSectionTabs: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: { type: 'static', value: false },
    },
  },
  showMenuName: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: { type: 'static', value: true },
    },
  },
  showMenuDescription: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: { type: 'static', value: true },
    },
  },
  showSectionName: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: { type: 'static', value: true },
    },
  },
  showSectionDividers: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: { type: 'static', value: true },
    },
  },
  showSectionImage: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: { type: 'static', value: true },
    },
  },
  showSectionDescription: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: { type: 'static', value: true },
    },
  },
  showItemDescription: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: { type: 'static', value: true },
    },
  },
  showItemPrice: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: { type: 'static', value: true },
    },
  },
  showItemCurrency: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: { type: 'static', value: true },
    },
  },
  showItemDiscounts: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: { type: 'static', value: true },
    },
  },
  showItemLabels: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: { type: 'static', value: true },
    },
  },
  showItemLabelsName: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
  },
  showItemLabelsIcon: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
  },
  showItemImage: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: { type: 'static', value: true },
    },
  },
  showItemDividers: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: { type: 'static', value: true },
    },
  },
  showItemVariantsName: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: { type: 'static', value: true },
    },
  },
  showItemVariantsPrice: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: { type: 'static', value: true },
    },
  },
  showItemVariantsDiscounts: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: { type: 'static', value: true },
    },
  },
  showItemVariantsCurrency: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: { type: 'static', value: true },
    },
  },
  showItemVariantsDivider: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
  },
  showMenusSideImage: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
  },
  showModifierGroupName: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: { type: 'static', value: true },
    },
  },
  showModifierName: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: { type: 'static', value: true },
    },
  },
  showModifierPrice: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: { type: 'static', value: true },
    },
  },
  showModifierCurrency: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: { type: 'static', value: true },
    },
  },
  showDots: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
  },
  showColumnDividers: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
  },
  showItemGridDivider: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
  },
});
